module.exports = __webpack_public_path__ + "static/media/icon_sampling.4961139d.svg";